import React from 'react';
import classNames from 'classnames';
import '@/style/components/BrandedLoading.scss';

interface BrandedLoadingProps {
  className?: string;
  fullscreen?: boolean;
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

/**
 * Branded loading component with animated Leyona logo.
 */
export default function BrandedLoading({
  className,
  fullscreen = true,
  size = 'medium',
  showText = false,
}: BrandedLoadingProps) {
  const logoSizes = {
    small: { width: 70, height: 70 },
    medium: { width: 100, height: 100 },
    large: { width: 140, height: 140 },
  };

  const { width, height } = logoSizes[size];

  return (
    <div className={classNames('branded-loading', className, {
      'branded-loading--fullscreen': fullscreen,
      [`branded-loading--${size}`]: size,
    })}>
      <div className="branded-loading__content">
        <div className="branded-loading__logo">
          <svg
            width={width}
            height={height}
            viewBox="95 85 320 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="branded-loading__svg"
          >
            <defs>
              <linearGradient id="violetGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#8B7EC8', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#7A6DB8', stopOpacity: 1 }} />
              </linearGradient>

              <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#6BA3E8', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#5A92D7', stopOpacity: 1 }} />
              </linearGradient>

              <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#4ECBB0', stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: '#3DBA9F', stopOpacity: 1 }} />
              </linearGradient>
            </defs>

            <rect
              x="100"
              y="170"
              width="120"
              height="200"
              rx="60"
              ry="60"
              fill="url(#violetGradient)"
              opacity="0.9"
              className="branded-loading__bar branded-loading__bar--1"
            />

            <rect
              x="195"
              y="100"
              width="120"
              height="280"
              rx="60"
              ry="60"
              fill="url(#blueGradient)"
              opacity="0.85"
              className="branded-loading__bar branded-loading__bar--2"
            />

            <rect
              x="290"
              y="140"
              width="120"
              height="240"
              rx="60"
              ry="60"
              fill="url(#greenGradient)"
              opacity="0.9"
              className="branded-loading__bar branded-loading__bar--3"
            />
          </svg>
        </div>

        {showText && (
          <div className="branded-loading__text">
            Leyona
          </div>
        )}
      </div>
    </div>
  );
}
